import React, { FC } from 'react';

import { IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import { Box } from '@mui/system';

import SelectAllHeader from '../../../DynamicTable/SelectAllHeader';
import { useAppDispatch } from '../../../../hooks/useAppDispatch';
import { resetDialog } from '../../../../reducers/dialogReducer';
import strings from '../../../../localization';

import styles from './styles';

interface IBookingReportHeader {
  selectAll: boolean;
  handleSelectAll: (toBeSet: boolean) => void;
}

const BookingReportHeader: FC<IBookingReportHeader> = ({
  selectAll,
  handleSelectAll,
}) => {
  const dispatch = useAppDispatch();

  const closeDialog = () => {
    dispatch(resetDialog());
  };

  return (
    <Box>
      <Box sx={styles.container}>
        <Typography sx={styles.title}>{strings.bookingReport}</Typography>
        <IconButton onClick={closeDialog}>
          <Close />
        </IconButton>
      </Box>
      <Box sx={styles.selectHeader}>
        <SelectAllHeader
          selectAll={selectAll}
          handleSelectAll={handleSelectAll}
        />
      </Box>
    </Box>
  );
};
export default BookingReportHeader;
